import HotelListCard from './HotelListCard';

export default HotelListCard
